<!--
 * @Author: lzz
 * @Date: 2024-06-08 10:27:41
 * @LastEditTime: 2024-09-03 08:59:23
-->
<template>
	<div id="app" :class="{ 'is-mobile': isMobile }">
		<base-home
			v-if="loadOver && !['index', 'departCaseDetails', 'partyBuildDetails', 'departLandDetails', 'forLogin', 'msgDetails', 'socialLogin'].includes($route.name) && $route.name !== null"
		></base-home>
		<router-view :isMobile="isMobile" />
	</div>
</template>

<script>
import baseHome from "@/components/baseHome.vue";
import { checkMobile } from "@/utils/index";

export default {
	name: "App",
	components: {
		baseHome,
	},
	created() {
		window.addEventListener(
			"mousewheel",
			function (event) {
				if (event.ctrlKey === true || event.metaKey) {
					event.preventDefault();
				}
			},
			{ passive: false }
		);
	},

	data() {
		return {
			isMobile: false,
			loadOver: false,
		};
	},
	mounted() {
		this.isMobile = checkMobile();
		this.forbidZoom(); // dom挂载完成后，及禁止浏览器缩放
		this.forbidZoomClick();
		this.forbidZoomDoubleClick();
		this.$nextTick(() => {
			this.loadOver = true;
			console.log(this);
			console.log(this.$route.name);
		});
	},

	methods: {
		// 禁止缩放(浏览器中)
		forbidZoom() {
			document.addEventListener(
				"keydown",
				function (event) {
					if (
						(event.ctrlKey === true || event.metaKey === true) &&
						(event.keyCode === 61 || event.keyCode === 107 || event.keyCode === 173 || event.keyCode === 109 || event.keyCode === 187 || event.keyCode === 189)
					) {
						event.preventDefault();
					}
				},
				false
			);

			document.addEventListener(
				"mousewheel",
				function (e) {
					e = e || window.event;
					// @ts-ignore
					if ((e.wheelDelta && event.ctrlKey) || e.detail) {
						event.preventDefault();
					}
				},
				{
					capture: false,
					passive: false,
				}
			);
		},

		// 禁止双指放大（手机端）
		forbidZoomClick() {
			document.documentElement.addEventListener(
				"touchstart",
				function (event) {
					if (event.touches.length > 1) {
						event.preventDefault();
					}
				},
				false
			);
		},

		// 禁止双击屏幕放大（手机端）
		forbidZoomDoubleClick() {
			var lastTouchEnd = 0;

			document.documentElement.addEventListener(
				"touchend",
				function (event) {
					var now = Date.now();
					if (now - lastTouchEnd <= 300) {
						event.preventDefault();
					}
					lastTouchEnd = now;
				},
				false
			);
		},
	},
};
</script>

<style lang="scss">
@import url("@/assets/css/common.css");

.el-icon-zoom-out,
.el-icon-zoom-in,
.el-image-viewer__actions__divider,
.el-icon-full-screen,
.el-image-viewer__actions__divider,
.el-icon-refresh-left,
.el-icon-refresh-right {
	display: none !important;
}

.el-image-viewer__actions {
	height: 4vh !important;
	width: auto !important;
	padding: 0 10px !important;
	cursor: pointer !important;
}

.el-image-viewer__actions__inner {
	cursor: pointer !important;
}
.el-image-viewer__actions__inner >span{
	display: flex !important;
    height: 4vh !important;
    justify-content: center !important;
    align-items: center !important;
}
.comment-list svg {
	width: 0.833vw !important;
	height: 0.833vw !important;
	vertical-align: top !important;
}

::-webkit-scrollbar {
	width: 0.416vw;
}

::-webkit-scrollbar-track {
	background: #ffffff;
	border-radius: 0.208vw;
}

::-webkit-scrollbar-thumb {
	background: #edf1f9;
	border-radius: 0.208vw;
}

/* 定义进入与离开的过渡效果 */
.lesson-item-enter-active,
.lesson-item-leave-active {
	transition: opacity 0.6s;
}

.lesson-item-enter,
.lesson-item-leave-to

/* .lesson-item-leave-active 在Vue 2.1.8+ 版本中 */ {
	opacity: 0;
}

.lesson-item {
	cursor: pointer;
}

.is-mobile {
	.el-image-viewer__actions{
		height: 30px !important;
	}
	.certificate-process-item span {
		height: 0.94vw !important;
		line-height: 0.94vw !important;
		vertical-align: middle !important;
	}

	.certificate-process img {
		width: 0.94vw !important;
		height: 0.94vw !important;
		vertical-align: middle !important;
		margin-left: 0.5vw;
		margin-top: 0 !important;
	}

	.el-input__icon {
		line-height: 5vh !important;
	}

	.certificate-process-item .icon {
		margin: 0 0 0 0.67vw !important;
		vertical-align: middle !important;
	}

	.evaluate-content .btn {
		font-size: 1.2vw;
	}

	.exam-content .exam .btn {
		font-size: 1.2vw;
	}

	.el-cascader__tags .el-tag {
		height: 4vh;
		padding: 0 8px;
		line-height: 4vh;
		font-size: 1.2vw;
		margin: 0;
	}

	.el-input__inner {
		height: 5vh !important;
		font-size: 1vw;
	}

	.el-cascader {
		font-size: 1.2vw;
		line-height: 4vh;
		height: 4vh;
	}

	.el-cascader .el-input .el-icon-arrow-down {
		vertical-align: top;
	}

	.el-cascader__tags {
		margin-top: 0.5vh;
	}
}

.depart {
	position: absolute;
	top: 8.5vh;
	//left: 6.4vw;
	// right: 6.25vw;
	// bottom: 19.2vh;
	left: 50%;
	transform: translateX(-50%);
	height: 72.22vh;
	width: 87.24%;
	overflow: hidden;

	.top {
		height: 9.44vh;
		// width: 100%;
		position: relative;

		&-operate {
			position: absolute;
			left: 86%;
			top: 0;
			height: 100%;
		}

		.title {
			font-weight: bold;
			display: flex;
			align-items: center;
			position: absolute;
			left: 20%;
			top: 12%;
			font-weight: 800;
			font-size: 1.5vw;
			text-shadow: 0.3125vw 0.3646vw 0.26vw rgba(255, 132, 132, 0.35);
			// background: linear-gradient(-4deg, #d50011 0%, #e60012 100%);
			// -webkit-background-clip: text;
			// -webkit-text-fill-color: transparent;
			color: #d50011;
		}
	}
}
</style>
